<div class="game-card" (click)="onClick()">
  <div
    class="game-card-inner"
    [ngStyle]="{
      background:
        cardBackground ||
        'linear-gradient(180deg,#ef3d67 0%,#7b5cff 45%,#1db8ff 100%)',
    }"
  >
    <div *ngIf="game?.isHot" class="hot-ribbon-wrap">
      <div class="hot-ribbon">HOT</div>
    </div>
    <img
      [src]="cardImage"
      [alt]="displayName"
      class="game-logo"
      [class.rotate]="rotate"
    />
  </div>

  <div class="game-card-footer">
    <span class="game-name">
      {{ displayName }}
    </span>

    <span class="game-status" [class.active]="statusActive">
      <span class="status-dot" *ngIf="statusActive"></span>

      <svg
        *ngIf="!statusActive"
        class="play-icon"
        viewBox="0 0 24 24"
        fill="currentColor"
      >
        <path d="M8 5v14l11-7z" />
      </svg>

      {{ statusLabel }}
    </span>
  </div>
</div>
